import { render, staticRenderFns } from "./SalesPaymentForm.vue?vue&type=template&id=17156ec6"
import script from "./SalesPaymentForm.vue?vue&type=script&lang=js"
export * from "./SalesPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports